import { useEffect, useRef, type CSSProperties } from 'react'

interface BitmapCanvasProps {
  bitmap: ImageBitmap
  ariaLabel: string
  testId?: string
  className?: string
  style?: CSSProperties
}

export function BitmapCanvas({ bitmap, ariaLabel, testId, className, style }: BitmapCanvasProps) {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    const canvas = canvasRef.current
    if (!canvas) throw new Error('Quality bitmap canvas element is missing')
    const context = canvas.getContext('2d')
    if (!context) throw new Error('Quality bitmap canvas requires a 2D context')
    context.imageSmoothingEnabled = false
    context.clearRect(0, 0, canvas.width, canvas.height)
    context.drawImage(bitmap, 0, 0)
  }, [bitmap])

  return (
    <canvas
      ref={canvasRef}
      width={bitmap.width}
      height={bitmap.height}
      className={className}
      style={style}
      data-testid={testId}
      aria-label={ariaLabel}
    />
  )
}
